// Emulation of page up/page down within editor
// Chrome has a bug in that page up/page down will affect horizontal scroll which will scroll the canvas
// It doesn't seem to get fixed anytime soon. :(
// https://bugs.chromium.org/p/chromium/issues/detail?id=890248&q=textarea%20scroll%20page%20up&can=2
// This function disables native behavior and emulates page up/page down
// Only works with the iframe editor (non-inline)
import { Editor, TinyMCE } from "@lifecare-welfare/tinymce-enterprise";

export default function tinyPageUpDownScrollFix(editor: Editor, tinymce: TinyMCE) {
    if (!(window as any).chrome) {
        return;
    }

    console.debug("TinyMCE page up/down emulation enabled");

    const troubleshoot = false;

    function debug(...params: any[]) {
        if (troubleshoot) {
            console.debug(...params);
        }
    }

    const magicAntiDriftingNumberUp = 0;
    const magicAntiDriftingNumberDown = 3; // There is a little bit of drifting of caret vs scroll on page down, we try to minimize it.
    const magicEndOfDocumentCorrection = 20; // To make getCaretRangeFromPoint happy when selecting from end of document

    editor.on("keydown", function (event) {
        const iframeWindow = editor.getWin();

        const x = iframeWindow.scrollX;
        const y = iframeWindow.scrollY;

        const clientHeight = editor.getContentAreaContainer().clientHeight;
        debug(clientHeight);

        if (event.which === 33) {
            debug("pageup");
            debug(event);

            event.preventDefault(); // Turn off standard behavior

            iframeWindow.scrollTo(x, Math.max(0, y - clientHeight)); // Scroll editor

            // Find out scroll coordinates for current caret position

            const selection = editor.selection.getSel();
            const range = selection.getRangeAt(0);

            if (range) {
                const rects = range.getClientRects();
                debug("rect count", rects.length);
                if (rects.length > 0) {
                    const rect = rects[0];
                    debug(rect);

                    // Calculate where we want it to be now

                    const desiredX = rect.left;
                    const desiredY = rect.top - clientHeight + magicAntiDriftingNumberUp;
                    debug("desired", { desiredX, desiredY });

                    const desiredRange = tinymce.dom.RangeUtils.getCaretRangeFromPoint(
                        desiredX,
                        desiredY,
                        editor.getDoc()
                    );
                    debug(desiredRange);

                    // Set position but handle beginning of document case separately

                    if (desiredRange) {
                        // Still in document
                        editor.selection.setRng(desiredRange, false);
                    } else {
                        // Reached the top of the document, move caret first
                        editor.selection.select(editor.getBody(), true);
                        editor.selection.collapse(true);
                    }
                } else {
                    // Special case, we are probably at end of document
                    debug("Special case, no rect found");

                    // Try to find a range at the end of the document

                    const desiredX = iframeWindow.innerWidth - magicEndOfDocumentCorrection;
                    const desiredY = iframeWindow.innerHeight - magicEndOfDocumentCorrection;
                    debug("desired", { desiredX, desiredY });

                    const desiredRange = tinymce.dom.RangeUtils.getCaretRangeFromPoint(
                        desiredX,
                        desiredY,
                        editor.getDoc()
                    );
                    debug(desiredRange);

                    if (desiredRange) {
                        // Still in document, set caret position
                        editor.selection.setRng(desiredRange, false);
                    } else {
                        // Reached the top of the document, move caret to front of document
                        editor.selection.select(editor.getBody(), true);
                        editor.selection.collapse(true);
                    }
                }
            } else {
                console.warn("PageUpDownFix: Pageup had no range. Missing case?");
            }
        }
        if (event.which === 34) {
            debug("pagedown");
            debug(event);

            event.preventDefault(); // Turn off standard behavior

            iframeWindow.scrollTo(x, y + clientHeight); // Scroll editor

            // Find out scroll coordinates for current caret position

            const selection = editor.selection.getSel();
            const range = selection.getRangeAt(0);
            if (range) {
                const rects = range.getClientRects();
                debug("rect count", rects.length);
                if (rects.length > 0) {
                    const rect = rects[rects.length - 1];
                    debug(rect);

                    // Calculate where we want it to be now

                    const desiredX = rect.right;
                    const desiredY = rect.top + clientHeight + magicAntiDriftingNumberDown;

                    const desiredRange = tinymce.dom.RangeUtils.getCaretRangeFromPoint(
                        desiredX,
                        desiredY,
                        editor.getDoc()
                    );
                    debug(desiredRange);

                    // Set position but handle end of document case separately

                    if (desiredRange) {
                        // Still in document
                        editor.selection.setRng(desiredRange, true);
                    } else {
                        // Reached the end of the document, move caret last
                        editor.selection.select(editor.getBody(), true);
                        editor.selection.collapse(false);
                    }
                }
            } else {
                console.warn("PageUpDownFix: Pagedown had no range. Missing case?");
            }
        }
    });
}
